{
  "hero": {
    "loading": "Se încarcă conținutul...",
    "headline": {
      "line1": "Conținut strategic pentru afaceri.",
      "line2": "Eficiență și profesionalism în marketing digital"
    },
    "subheadline": "Tehnologia, design-ul și videografia se unesc pentru a rezolva probleme reale",
    "primaryCta": "Vezi proiecte",
    "secondaryCta": "Rezervă o sesiune de strategie în Timișoara"
  },
  "hook": "Investiția în conținut video nu este doar un trend — este o mișcare strategică pentru a-ți dezvolta afacerea și a rămâne relevant pe piața competitivă de astăzi.",
  "industry": {
    "title": "Soluții media pentru industria ta",
    "options": {
      "ecommerce": "Afaceri e-commerce",
      "restaurants": "Restaurante și cafenele",
      "retail": "Magazine retail",
      "salons": "Saloane și spa-uri",
      "fitness": "Centre fitness și săli de sport",
      "realestate": "Agenții imobiliare",
      "professional": "Servicii profesionale",
      "homeservices": "Servicii pentru casă"
    }
  },
  "problem": {
    "heading": "De ce majoritatea proiectelor digitale nu rezonează.",
    "copy": "Angajezi un dezvoltator pentru cod, un designer pentru un logo și un videograf pentru conținut. Rezultatul? Un brand fragmentat care se simte deconectat. Am petrecut două decenii văzând site-uri web lansate cu cod excelent dar conținut 'gol'. Khromatik a fost construit pentru a rezolva asta."
  },
  "pillars": {
    "architect": {
      "title": "Arhitectul",
      "subtitle": "Consultanță",
      "description": "Audituri UI/UX și arhitectură Frontend pentru platforme complexe. Expertiză de nivel senior pentru provocări mari."
    },
    "builder": {
      "title": "Constructorul",
      "subtitle": "Dezvoltare",
      "description": "Identități de brand personalizate și site-uri web de înaltă viteză care transformă efectiv vizitatorii în clienți."
    },
    "storyteller": {
      "title": "Povestitorul",
      "subtitle": "Conținut",
      "description": "Video și fotografie cinematice filmate la fața locului în Timișoara pentru a da tehnologiei tale un suflet uman."
    }
  },
  "holisticEdge": {
    "heading": "O viziune clară. Implementare fluidă.",
    "workflow": {
      "strategy": "Strategie",
      "design": "Design",
      "code": "Cod",
      "content": "Conținut",
      "launch": "Lansare"
    },
    "valueProposition": "Pentru că filmez video-ul și scriu codul, site-ul tău este proiectat în jurul poveștii tale, nu invers."
  },
  "socialProof": {
    "heading": "De încredere de 20 de ani",
    "recommendations": {
      "heading": "Recomandări"
    },
    "featuredProject": {
      "title": "Proiect recomandat",
      "projectTitle": "Lansare parteneriat Polestar",
      "description": "O campanie completă în care am gestionat branding-ul, site-ul web și videoclipul—toate dintr-o singură viziune.",
      "cta": "Vezi studiul de caz"
    }
  },
  "localPresence": {
    "heading": "Calitate de înaltă clasă, livrată local",
    "copy": "Bazat în Timișoara, ofer calitate de piață occidentală cu beneficiul unei parteneriate locale, față în față. Fie că este o zi de conținut la biroul tău din Arad sau un workshop UI în inima Timișoarei, sunt departamentul tău creativ la apel."
  },
  "packages": {
    "heading": "Alege-ți calea",
    "audit": {
      "title": "Auditul",
      "description": "Câștig rapid pentru companii mari. Audit UI/UX și recomandări strategice.",
      "cta": "Află mai multe"
    },
    "launch": {
      "title": "Lansarea",
      "description": "Pentru branduri noi. Identitate digitală completă de la concept la lansare.",
      "cta": "Află mai multe"
    },
    "partnership": {
      "title": "Parteneriatul",
      "description": "Retainer lunar de conținut. Suport continuu pentru afaceri în creștere.",
      "cta": "Află mai multe"
    }
  },
  "footerCta": {
    "heading": "Gata să-ți unifici prezența digitală?",
    "contactText": "Hai să discutăm despre proiectul tău",
    "bookSession": "Rezervă o sesiune de strategie",
    "or": "sau",
    "contactLink": "Ia legătura"
  }
}
